export default [{"url":"https://securedgrid-0.api.invexerp.io","name":"Branch 1","port":"6527","isStore":true,"isHQ":true}]